import { List, TextField, EditButton, ShowButton, SimpleList, Datagrid, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT, PROFESSIONAL_DIRECTIONS } from "utils/constants";
import { AdministrationExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListDirections = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={AdministrationExporter(PROFESSIONAL_DIRECTIONS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Професионални направления"
      sx={settings.style.expandStyle}
      actions={
        <ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateProfessionalDirections)} />
      }
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.nameBg }]} />}
          tertiaryText={() => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateProfessionalDirections) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име"
            sortable={false}
          />

          {checkPermission(userPermissions, permissions.canUpdateProfessionalDirections) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListDirections;
